module.exports = __webpack_public_path__ + "static/media/study.ef1243f3.jpg";